import { useTranslation } from 'react-i18next';
import { WebFormThemeTemplateEnum } from '../models/enums/webFormThemeTemplate.enum';
import { SelectableItem } from '../models/gui/selectableItem';
import { WebFormLangTemplateEnum } from '../models/enums/webFormLangTemplate.enum';

export const useWebFormArrays = () => {
  const { t } = useTranslation();
  const themeTemplateArray: SelectableItem[] = [
    {
      value: `${WebFormThemeTemplateEnum.Standard}`,
      label: t(`fundraiser:fundraiserTemplate.${WebFormThemeTemplateEnum.Standard}`),
    },
    {
      value: `${WebFormThemeTemplateEnum.DarkSeaGreen}`,
      label: t(`fundraiser:fundraiserTemplate.${WebFormThemeTemplateEnum.DarkSeaGreen}`),
    },
    {
      value: `${WebFormThemeTemplateEnum.DarkRed}`,
      label: t(`fundraiser:fundraiserTemplate.${WebFormThemeTemplateEnum.DarkRed}`),
    },
    {
      value: `${WebFormThemeTemplateEnum.Purple}`,
      label: t(`fundraiser:fundraiserTemplate.${WebFormThemeTemplateEnum.Purple}`),
    },
  ];

  const langTemplateArray: SelectableItem[] = [
    {
      value: `${WebFormLangTemplateEnum.Swedish}`,
      label: t(`fundraiser:fundraiserLanguage.${WebFormLangTemplateEnum.Swedish}`),
    },
    {
      value: `${WebFormLangTemplateEnum.English}`,
      label: t(`fundraiser:fundraiserLanguage.${WebFormLangTemplateEnum.English}`),
    },
  ];

  return { themeTemplateArray, langTemplateArray };
};
